import { EligibleReward, TokenCartItem, TokenCartObj } from './types';

export class TokenCart {
  _tokenCartObj: TokenCartObj;
  _eligibleRewards: EligibleReward[];

  constructor(tokenCartObj: TokenCartObj, eligibleRewards: EligibleReward[]) {
    this._eligibleRewards = eligibleRewards;
    tokenCartObj = tokenCartObj || {};
    this._tokenCartObj = { ...tokenCartObj };

    // The reward is not stored in the token cart from the API.
    // This fn maps the reward is attached in the cart per item, which makes things quite a bit simpler.
    this._updateTokenCartItems(tokenCartObj.items || []);
  }

  get items(): TokenCartItem[] {
    return this._tokenCartObj.items;
  }

  set items(items: TokenCartItem[]) {
    this._updateTokenCartItems(items);
  }

  get cart() {
    return this._tokenCartObj;
  }

  _updateTokenCartItems(items: TokenCartItem[]) {
    this._tokenCartObj.items = items.map((item) => {
      return {
        ...item,
        reward: item.reward
          ? item.reward
          : this._eligibleRewards.find((eligibleReward) => {
              return this.isItemUsedForReward(item, eligibleReward);
            })
      };
    });
  }

  isItemUsedForReward(item: TokenCartItem, eligibleReward: EligibleReward) {
    return (
      item.campaignId === eligibleReward.campaignId &&
      item.token.network === eligibleReward.token.network &&
      item.token.contractAddress === eligibleReward.token.contractAddress &&
      item.token.tokenId === eligibleReward.token.tokenId
    );
  }

  findItemsWithReward(reward: EligibleReward): TokenCartItem[] {
    return this.items.filter((item) => {
      return this.isItemUsedForReward(item, reward);
    });
  }
}
